// ============================================================
// 肉羊营养需要量查表模块（基于NY/T 816-2021）
// ============================================================

/**
 * 生长育肥母羊表（表3）
 * 体重范围：20-60kg，日增重：100/200/300/350g
 */
const GROW_FEMALE_TABLE = [
  { weight: 20, adg: 100, dmi: 0.62, cp: 86 },
  { weight: 20, adg: 200, dmi: 0.74, cp: 104 },
  { weight: 20, adg: 300, dmi: 0.85, cp: 121 },
  { weight: 20, adg: 350, dmi: 0.92, cp: 129 },
  { weight: 25, adg: 100, dmi: 0.7, cp: 97 },
  { weight: 25, adg: 200, dmi: 0.82, cp: 114 },
  { weight: 25, adg: 300, dmi: 0.93, cp: 131 },
  { weight: 25, adg: 350, dmi: 0.99, cp: 140 },
  { weight: 30, adg: 100, dmi: 0.8, cp: 108 },
  { weight: 30, adg: 200, dmi: 0.92, cp: 126 },
  { weight: 30, adg: 300, dmi: 1.03, cp: 144 },
  { weight: 30, adg: 350, dmi: 1.09, cp: 152 },
  { weight: 35, adg: 100, dmi: 0.91, cp: 120 },
  { weight: 35, adg: 200, dmi: 1.04, cp: 137 },
  { weight: 35, adg: 300, dmi: 1.17, cp: 155 },
  { weight: 35, adg: 350, dmi: 1.24, cp: 165 },
  { weight: 40, adg: 100, dmi: 1.01, cp: 133 },
  { weight: 40, adg: 200, dmi: 1.13, cp: 150 },
  { weight: 40, adg: 300, dmi: 1.26, cp: 167 },
  { weight: 40, adg: 350, dmi: 1.34, cp: 176 },
  { weight: 45, adg: 100, dmi: 1.12, cp: 145 },
  { weight: 45, adg: 200, dmi: 1.24, cp: 161 },
  { weight: 45, adg: 300, dmi: 1.35, cp: 178 },
  { weight: 45, adg: 350, dmi: 1.42, cp: 188 },
  { weight: 50, adg: 100, dmi: 1.24, cp: 158 },
  { weight: 50, adg: 200, dmi: 1.36, cp: 174 },
  { weight: 50, adg: 300, dmi: 1.48, cp: 190 },
  { weight: 50, adg: 350, dmi: 1.55, cp: 197 },
  { weight: 55, adg: 100, dmi: 1.35, cp: 173 },
  { weight: 55, adg: 200, dmi: 1.47, cp: 190 },
  { weight: 55, adg: 300, dmi: 1.59, cp: 206 },
  { weight: 55, adg: 350, dmi: 1.66, cp: 215 },
  { weight: 60, adg: 100, dmi: 1.48, cp: 184 },
  { weight: 60, adg: 200, dmi: 1.61, cp: 200 },
  { weight: 60, adg: 300, dmi: 1.73, cp: 217 },
  { weight: 60, adg: 350, dmi: 1.8, cp: 228 },
];

/**
 * 生长育肥公羊表（表2）
 * 体重范围：20-60kg，日增重：100/200/300/350g
 */
const GROW_MALE_TABLE = [
  { weight: 20, adg: 100, dmi: 0.71, cp: 95 },
  { weight: 20, adg: 200, dmi: 0.85, cp: 119 },
  { weight: 20, adg: 300, dmi: 0.95, cp: 139 },
  { weight: 25, adg: 100, dmi: 0.8, cp: 112 },
  { weight: 25, adg: 200, dmi: 0.94, cp: 132 },
  { weight: 25, adg: 300, dmi: 0.93, cp: 144 },
  { weight: 30, adg: 100, dmi: 1.02, cp: 143 },
  { weight: 30, adg: 200, dmi: 1.01, cp: 159 },
  { weight: 30, adg: 300, dmi: 1.2, cp: 187 },
  { weight: 35, adg: 100, dmi: 1.12, cp: 169 },
  { weight: 35, adg: 200, dmi: 1.31, cp: 181 },
  { weight: 35, adg: 300, dmi: 1.38, cp: 204 },
  { weight: 35, adg: 350, dmi: 1.48, cp: 207 },
  { weight: 40, adg: 100, dmi: 1.22, cp: 167 },
  { weight: 40, adg: 200, dmi: 1.41, cp: 183 },
  { weight: 40, adg: 300, dmi: 1.48, cp: 193 },
  { weight: 40, adg: 350, dmi: 1.5, cp: 215 },
  { weight: 45, adg: 100, dmi: 1.33, cp: 159 },
  { weight: 45, adg: 200, dmi: 1.51, cp: 196 },
  { weight: 45, adg: 300, dmi: 1.57, cp: 204 },
  { weight: 45, adg: 350, dmi: 1.7, cp: 221 },
  { weight: 50, adg: 100, dmi: 1.43, cp: 173 },
  { weight: 50, adg: 200, dmi: 1.61, cp: 209 },
  { weight: 50, adg: 300, dmi: 1.66, cp: 216 },
  { weight: 50, adg: 350, dmi: 1.76, cp: 230 },
  { weight: 55, adg: 100, dmi: 1.53, cp: 199 },
  { weight: 55, adg: 200, dmi: 1.72, cp: 225 },
  { weight: 55, adg: 300, dmi: 1.8, cp: 233 },
  { weight: 55, adg: 350, dmi: 1.95, cp: 255 },
  { weight: 60, adg: 100, dmi: 1.63, cp: 212 },
  { weight: 60, adg: 200, dmi: 1.82, cp: 238 },
  { weight: 60, adg: 300, dmi: 1.91, cp: 248 },
  { weight: 60, adg: 350, dmi: 2.05, cp: 265 },
];

/**
 * 哺乳羔羊表（表1）- 公母通用
 * 体重范围：6-18kg，日增重：100/200/300g
 */
const LAMB_TABLE = [
  { weight: 6, adg: 100, dmi: 0.16, cp: 26 },
  { weight: 6, adg: 200, dmi: 0.19, cp: 31 },
  { weight: 8, adg: 100, dmi: 0.27, cp: 44 },
  { weight: 8, adg: 200, dmi: 0.32, cp: 51 },
  { weight: 8, adg: 300, dmi: 0.35, cp: 56 },
  { weight: 10, adg: 100, dmi: 0.39, cp: 63 },
  { weight: 10, adg: 200, dmi: 0.46, cp: 74 },
  { weight: 10, adg: 300, dmi: 0.51, cp: 82 },
  { weight: 12, adg: 100, dmi: 0.53, cp: 83 },
  { weight: 12, adg: 200, dmi: 0.63, cp: 97 },
  { weight: 12, adg: 300, dmi: 0.69, cp: 108 },
  { weight: 14, adg: 100, dmi: 0.52, cp: 85 },
  { weight: 14, adg: 200, dmi: 0.61, cp: 102 },
  { weight: 14, adg: 300, dmi: 0.67, cp: 111 },
  { weight: 16, adg: 100, dmi: 0.64, cp: 103 },
  { weight: 16, adg: 200, dmi: 0.75, cp: 121 },
  { weight: 16, adg: 300, dmi: 0.84, cp: 134 },
  { weight: 18, adg: 100, dmi: 0.75, cp: 122 },
  { weight: 18, adg: 200, dmi: 0.88, cp: 147 },
  { weight: 18, adg: 300, dmi: 0.98, cp: 155 },
];

// ============================================================
// 核心插值函数
// ============================================================

function interpolateByAdg(adg, rows, field, label) {
  if (!rows || rows.length === 0) return 0;
  if (rows.length === 1) return rows[0][field];

  const sorted = [...rows].sort((a, b) => a.adg - b.adg);

  if (adg <= sorted[0].adg) {
    return sorted[0][field];
  }
  if (adg >= sorted[sorted.length - 1].adg) {
    return sorted[sorted.length - 1][field];
  }

  for (let i = 0; i < sorted.length - 1; i++) {
    const low = sorted[i];
    const high = sorted[i + 1];
    if (adg >= low.adg && adg <= high.adg) {
      const ratio = (adg - low.adg) / (high.adg - low.adg);
      return low[field] + (high[field] - low[field]) * ratio;
    }
  }

  return sorted[sorted.length - 1][field];
}

function bilinearInterpolate(weight, adg, table, field) {
  const weights = [...new Set(table.map((r) => r.weight))].sort(
    (a, b) => a - b
  );

  let w1 = weights[0],
    w2 = weights[weights.length - 1];
  for (let i = 0; i < weights.length - 1; i++) {
    if (weight >= weights[i] && weight <= weights[i + 1]) {
      w1 = weights[i];
      w2 = weights[i + 1];
      break;
    }
  }
  if (weight <= weights[0]) {
    w1 = weights[0];
    w2 = weights[0];
  }
  if (weight >= weights[weights.length - 1]) {
    w1 = weights[weights.length - 1];
    w2 = weights[weights.length - 1];
  }

  const rows1 = table.filter((r) => r.weight === w1);
  const rows2 = table.filter((r) => r.weight === w2);

  const val1 = interpolateByAdg(adg, rows1, field, `${w1}kg`);
  const val2 = interpolateByAdg(adg, rows2, field, `${w2}kg`);

  if (w1 === w2) {
    return val1;
  }

  const weightRatio = (weight - w1) / (w2 - w1);
  return val1 + (val2 - val1) * weightRatio;
}

function queryDMIAndCP(weight, adg, type) {
  let dmi, cp;

  if (type === "female") {
    if (weight < 20) {
      const effectiveWeight = Math.max(weight, 6);
      dmi = bilinearInterpolate(effectiveWeight, adg, LAMB_TABLE, "dmi");
      cp = bilinearInterpolate(effectiveWeight, adg, LAMB_TABLE, "cp");
    } else {
      dmi = bilinearInterpolate(weight, adg, GROW_FEMALE_TABLE, "dmi");
      cp = bilinearInterpolate(weight, adg, GROW_FEMALE_TABLE, "cp");
    }
  } else {
    if (weight < 20) {
      const effectiveWeight = Math.max(weight, 6);
      dmi = bilinearInterpolate(effectiveWeight, adg, LAMB_TABLE, "dmi");
      cp = bilinearInterpolate(effectiveWeight, adg, LAMB_TABLE, "cp");
    } else {
      dmi = bilinearInterpolate(weight, adg, GROW_MALE_TABLE, "dmi");
      cp = bilinearInterpolate(weight, adg, GROW_MALE_TABLE, "cp");
    }
  }

  return { dmi, cp };
}

// ============================================================
// 秸秆配置
// ============================================================

const STRAW_PER_MEAL_CONFIG = [
  { startDay: 1, endDay: 15, liang: 2 },
  { startDay: 16, endDay: 30, liang: 1.5 },
  { startDay: 31, endDay: 70, liang: 1 },
  { startDay: 71, endDay: 120, liang: 0.5 },
];

function getStrawPerMeal(day) {
  for (const config of STRAW_PER_MEAL_CONFIG) {
    if (day >= config.startDay && day <= config.endDay) {
      return config.liang / 10;
    }
  }
  return 0.05;
}

// ============================================================
// 核心：生成固定的每日配料数据（支持按天/按顿）
// ============================================================

function generateFixedFeedArray(
  totalDays,
  type,
  startWeightJin,
  granularity = "day"
) {
  if (totalDays <= 0) {
    return [];
  }

  const isFemale = type === "female";
  const totalMeals = totalDays * 2;

  if (isFemale) {
    const BASE_START_WEIGHT = 20;
    const START_FEED = 0.1;
    const PROTEIN_START = 19.0;

    const PEAK_FEED_MIN = 1.18;
    const PEAK_FEED_MAX = 1.2;
    const peakFeed =
      Math.round(
        (Math.random() * (PEAK_FEED_MAX - PEAK_FEED_MIN) + PEAK_FEED_MIN) * 100
      ) / 100;

    const PROTEIN_PEAK_MIN = 15.0;
    const PROTEIN_PEAK_MAX = 15.5;
    const peakProtein =
      Math.round(
        (Math.random() * (PROTEIN_PEAK_MAX - PROTEIN_PEAK_MIN) +
          PROTEIN_PEAK_MIN) *
          10
      ) / 10;

    let peakDay = Math.floor(totalDays * 0.85);
    if (peakDay < 1) peakDay = 1;

    let startFeed = START_FEED;
    if (startWeightJin < BASE_START_WEIGHT) {
      startFeed = START_FEED * (startWeightJin / BASE_START_WEIGHT);
      startFeed = Math.round(startFeed * 100) / 100;
    }
    if (startWeightJin > BASE_START_WEIGHT) {
      startFeed = START_FEED * (startWeightJin / BASE_START_WEIGHT);
      startFeed = Math.round(startFeed * 100) / 100;
    }

    console.log("========== 母羔固定参数 ==========");
    console.log(`进圈体重: ${startWeightJin}斤`);
    console.log(`起步配料: ${startFeed}斤/顿/只`);
    console.log(`峰值配料: ${peakFeed}斤/顿/只 (第${peakDay}天)`);
    console.log(`起步蛋白: ${PROTEIN_START}%`);
    console.log(`峰值蛋白: ${peakProtein}% (第${peakDay}天)`);
    console.log(`加料粒度: ${granularity === "day" ? "按天" : "按顿"}`);
    console.log("========================================\n");

    const result = [];

    if (granularity === "day") {
      const feedStep = (peakFeed - startFeed) / (peakDay - 1 || 1);
      const proteinStep = (peakProtein - PROTEIN_START) / (peakDay - 1 || 1);

      for (let day = 1; day <= totalDays; day++) {
        let feedPerMeal, targetProtein;

        if (day <= peakDay) {
          const offset = day - 1;
          feedPerMeal = startFeed + offset * feedStep;
          targetProtein = PROTEIN_START + offset * proteinStep;
        } else {
          feedPerMeal = peakFeed;
          targetProtein = peakProtein;
        }

        feedPerMeal = parseFloat(feedPerMeal.toFixed(4));
        targetProtein = Math.round(targetProtein * 10) / 10;

        result.push({
          day: day,
          feedPerMeal: feedPerMeal,
          feedPerDay: parseFloat((feedPerMeal * 2).toFixed(2)),
          targetProtein: targetProtein,
          isStable: day > peakDay,
        });
      }
    } else {
      const startMealIdx = 0;
      const peakMealIdx = (peakDay - 1) * 2 + 1;
      const totalMealsCount = totalDays * 2;

      const feedStep =
        (peakFeed - startFeed) / (peakMealIdx - startMealIdx || 1);
      const proteinStep =
        (peakProtein - PROTEIN_START) / (peakMealIdx - startMealIdx || 1);

      console.log(`按顿模式: 总顿数=${totalMealsCount}, 峰值顿=${peakMealIdx}`);
      console.log(`每顿饲料公差: ${feedStep.toFixed(6)} 斤`);
      console.log(`每顿蛋白公差: ${proteinStep.toFixed(6)} %`);

      for (let mealIdx = 0; mealIdx < totalMealsCount; mealIdx++) {
        const day = Math.floor(mealIdx / 2) + 1;
        let feedPerMeal, targetProtein;

        if (mealIdx <= peakMealIdx) {
          const offset = mealIdx - startMealIdx;
          feedPerMeal = startFeed + offset * feedStep;
          targetProtein = PROTEIN_START + offset * proteinStep;
        } else {
          feedPerMeal = peakFeed;
          targetProtein = peakProtein;
        }

        feedPerMeal = parseFloat(feedPerMeal.toFixed(4));
        targetProtein = Math.round(targetProtein * 10) / 10;

        result.push({
          day: day,
          mealIndex: mealIdx + 1,
          feedPerMeal: feedPerMeal,
          feedPerDay: parseFloat((feedPerMeal * 2).toFixed(2)),
          targetProtein: targetProtein,
          isStable: mealIdx > peakMealIdx,
        });
      }
    }

    return result;
  }

  if (type === "male") {
    const BASE_START_WEIGHT = 30;
    const START_FEED = 0.4;
    const PROTEIN_START = 20.5;

    const PEAK_FEED_MIN = 1.6;
    const PEAK_FEED_MAX = 1.7;
    const peakFeed =
      Math.round(
        (Math.random() * (PEAK_FEED_MAX - PEAK_FEED_MIN) + PEAK_FEED_MIN) * 100
      ) / 100;

    const PROTEIN_PEAK_MIN = 15.0;
    const PROTEIN_PEAK_MAX = 15.5;
    const peakProtein =
      Math.round(
        (Math.random() * (PROTEIN_PEAK_MAX - PROTEIN_PEAK_MIN) +
          PROTEIN_PEAK_MIN) *
          10
      ) / 10;

    let peakDay = Math.floor(totalDays * 0.85);
    if (peakDay < 1) peakDay = 1;

    let startFeed = START_FEED;
    if (startWeightJin < BASE_START_WEIGHT) {
      startFeed = START_FEED * (startWeightJin / BASE_START_WEIGHT);
      startFeed = Math.round(startFeed * 100) / 100;
    }
    if (startWeightJin > BASE_START_WEIGHT) {
      startFeed = START_FEED * (startWeightJin / BASE_START_WEIGHT);
      startFeed = Math.round(startFeed * 100) / 100;
    }

    console.log("========== 公羔固定参数 ==========");
    console.log(`进圈体重: ${startWeightJin}斤`);
    console.log(`起步配料: ${startFeed}斤/顿/只`);
    console.log(`峰值配料: ${peakFeed}斤/顿/只 (第${peakDay}天)`);
    console.log(`起步蛋白: ${PROTEIN_START}%`);
    console.log(`峰值蛋白: ${peakProtein}% (第${peakDay}天)`);
    console.log(`加料粒度: ${granularity === "day" ? "按天" : "按顿"}`);
    console.log("========================================\n");

    const result = [];

    if (granularity === "day") {
      const feedStep = (peakFeed - startFeed) / (peakDay - 1 || 1);
      const proteinStep = (peakProtein - PROTEIN_START) / (peakDay - 1 || 1);

      for (let day = 1; day <= totalDays; day++) {
        let feedPerMeal, targetProtein;

        if (day <= peakDay) {
          const offset = day - 1;
          feedPerMeal = startFeed + offset * feedStep;
          targetProtein = PROTEIN_START + offset * proteinStep;
        } else {
          feedPerMeal = peakFeed;
          targetProtein = peakProtein;
        }

        feedPerMeal = parseFloat(feedPerMeal.toFixed(4));
        targetProtein = Math.round(targetProtein * 10) / 10;

        result.push({
          day: day,
          feedPerMeal: feedPerMeal,
          feedPerDay: parseFloat((feedPerMeal * 2).toFixed(2)),
          targetProtein: targetProtein,
          isStable: day > peakDay,
        });
      }
    } else {
      const startMealIdx = 0;
      const peakMealIdx = (peakDay - 1) * 2 + 1;
      const totalMealsCount = totalDays * 2;

      const feedStep =
        (peakFeed - startFeed) / (peakMealIdx - startMealIdx || 1);
      const proteinStep =
        (peakProtein - PROTEIN_START) / (peakMealIdx - startMealIdx || 1);

      console.log(`按顿模式: 总顿数=${totalMealsCount}, 峰值顿=${peakMealIdx}`);
      console.log(`每顿饲料公差: ${feedStep.toFixed(6)} 斤`);
      console.log(`每顿蛋白公差: ${proteinStep.toFixed(6)} %`);

      for (let mealIdx = 0; mealIdx < totalMealsCount; mealIdx++) {
        const day = Math.floor(mealIdx / 2) + 1;
        let feedPerMeal, targetProtein;

        if (mealIdx <= peakMealIdx) {
          const offset = mealIdx - startMealIdx;
          feedPerMeal = startFeed + offset * feedStep;
          targetProtein = PROTEIN_START + offset * proteinStep;
        } else {
          feedPerMeal = peakFeed;
          targetProtein = peakProtein;
        }

        feedPerMeal = parseFloat(feedPerMeal.toFixed(4));
        targetProtein = Math.round(targetProtein * 10) / 10;

        result.push({
          day: day,
          mealIndex: mealIdx + 1,
          feedPerMeal: feedPerMeal,
          feedPerDay: parseFloat((feedPerMeal * 2).toFixed(2)),
          targetProtein: targetProtein,
          isStable: mealIdx > peakMealIdx,
        });
      }
    }

    return result;
  }

  return [];
}

function getRandomPeakFeed() {
  return Math.round((Math.random() * (1.15 - 1.1) + 1.1) * 100) / 100;
}

function getRandomPeakProtein() {
  return Math.round((Math.random() * (14.2 - 14.0) + 14.0) * 10) / 10;
}

// ============================================================
// 查询函数
// ============================================================

function queryFeedAmount(
  weightKg,
  adgG,
  type,
  day,
  strawCpPercent = 4,
  concentrateCpPercent = 18
) {
  const { dmi, cp } = queryDMIAndCP(weightKg, adgG, type);

  const dmiJinPerDay = dmi * 2;

  const strawJinPerMeal = getStrawPerMeal(day);
  const strawJinPerDay = strawJinPerMeal * 2;

  const concentrateJinPerDay = Math.max(0, dmiJinPerDay - strawJinPerDay);
  const concentrateJinPerMeal = concentrateJinPerDay / 2;

  const cpNeededG = cp;
  let targetProtein = 0;
  if (concentrateJinPerDay > 0) {
    targetProtein = (cpNeededG / (concentrateJinPerDay * 500)) * 100;
    targetProtein = Math.min(Math.max(targetProtein, 8), 45);
    targetProtein = Math.round(targetProtein * 10) / 10;
  }

  const strawCpProvided = strawJinPerDay * (strawCpPercent / 100);
  const concentrateCpProvided =
    concentrateJinPerDay * (concentrateCpPercent / 100);
  const totalCpActual = (strawCpProvided + concentrateCpProvided) * 500;

  return {
    dmiKg: Math.round(dmi * 100) / 100,
    dmiJinPerDay: Math.round(dmiJinPerDay * 100) / 100,
    cpNeededG: Math.round(cpNeededG),
    cpNeededJin: Math.round((cpNeededG / 500) * 100) / 100,
    targetProtein: targetProtein,
    strawJinPerDay: Math.round(strawJinPerDay * 100) / 100,
    strawJinPerMeal: Math.round(strawJinPerMeal * 100) / 100,
    strawCpProvidedJin: Math.round(strawCpProvided * 100) / 100,
    concentrateJinPerDay: Math.round(concentrateJinPerDay * 100) / 100,
    concentrateJinPerMeal: Math.round(concentrateJinPerMeal * 100) / 100,
    concentrateCpProvidedJin: Math.round(concentrateCpProvided * 100) / 100,
    totalCpActualG: Math.round(totalCpActual),
    cpTargetG: Math.round(cpNeededG),
    cpDeviation: Math.round(totalCpActual - cpNeededG),
  };
}

// ============================================================
// 添加剂生成函数
// ============================================================

function validateAdditivePhases(phases, additiveName) {
  console.log(
    `[validateAdditivePhases] 校验添加剂 "${additiveName}" 的阶段配置:`,
    JSON.stringify(phases, null, 2)
  );

  if (!phases || phases.length === 0) {
    return { valid: true, error: null, phases: [] };
  }

  const sortedPhases = [...phases].sort(
    (a, b) => (a.startDay || 0) - (b.startDay || 0)
  );

  for (let i = 0; i < sortedPhases.length; i++) {
    const phase = sortedPhases[i];
    const startDay = parseInt(phase.startDay) || 0;
    const endDay = parseInt(phase.endDay) || 0;
    const amount = parseFloat(phase.amount) || 0;

    if (startDay <= 0 || endDay <= 0) {
      return {
        valid: false,
        error: `"${additiveName}" 第${i + 1}阶段：开始天和结束天必须大于0`,
        phases: sortedPhases,
      };
    }

    if (startDay > endDay) {
      return {
        valid: false,
        error: `"${additiveName}" 第${
          i + 1
        }阶段：开始天(${startDay})不能大于结束天(${endDay})`,
        phases: sortedPhases,
      };
    }

    if (amount <= 0) {
      return {
        valid: false,
        error: `"${additiveName}" 第${i + 1}阶段：用量必须大于0`,
        phases: sortedPhases,
      };
    }
  }

  for (let i = 0; i < sortedPhases.length - 1; i++) {
    const current = sortedPhases[i];
    const next = sortedPhases[i + 1];
    const currentEnd = parseInt(current.endDay) || 0;
    const nextStart = parseInt(next.startDay) || 0;

    if (nextStart <= currentEnd) {
      return {
        valid: false,
        error: `"${additiveName}" 阶段重叠：第${
          i + 1
        }阶段结束于第${currentEnd}天，第${
          i + 2
        }阶段开始于第${nextStart}天（必须 ≥ ${currentEnd + 1}）`,
        phases: sortedPhases,
      };
    }
  }

  console.log(`[validateAdditivePhases] "${additiveName}" 校验通过`);
  return { valid: true, error: null, phases: sortedPhases };
}

/**
 * 计算添加剂的阶段分配（蛋白=0的饲料）
 * 固定间隔5天，等间距分配，结果取整
 */
function calculateAdditivePhases(startAmount, endAmount, totalDays) {
  const INTERVAL_DAYS = 5;

  if (totalDays <= 0) return [];
  if (startAmount === 0 && endAmount === 0) return [];

  const phaseCount = Math.ceil(totalDays / INTERVAL_DAYS);

  if (phaseCount <= 1) {
    return [
      {
        startDay: 1,
        endDay: totalDays,
        amount: Math.round(startAmount),
      },
    ];
  }

  const step = (endAmount - startAmount) / (phaseCount - 1);
  const phases = [];

  for (let i = 0; i < phaseCount; i++) {
    const amount = Math.round(startAmount + i * step);
    const startDay = i * INTERVAL_DAYS + 1;
    const endDay = Math.min((i + 1) * INTERVAL_DAYS, totalDays);
    phases.push({
      startDay: startDay,
      endDay: endDay,
      amount: amount,
    });
  }

  return phases;
}

/**
 * 生成添加剂数据（蛋白=0的饲料）
 * @param {Array} additives - 添加剂列表
 * @param {number} totalDays - 总天数
 * @param {number} peakDayForFeed - 采食量峰值日（用户设置的百分比计算得出）
 * @param {number|null} highProteinStartDay - 第一个蛋白>=30%全程饲料的startDay，没有则为null
 */
function generateAdditiveData(additives, totalDays, peakDayForFeed, highProteinStartDay = null) {
  console.log(
    "========== [generateAdditiveData] 开始生成添加剂数据 =========="
  );
  console.log(
    "[generateAdditiveData] 入参 additives:",
    JSON.stringify(additives, null, 2)
  );
  console.log("[generateAdditiveData] 总天数:", totalDays);
  console.log("[generateAdditiveData] 采食量峰值日:", peakDayForFeed);
  console.log("[generateAdditiveData] 高蛋白介入日:", highProteinStartDay);

  const result = {};

  if (!additives || additives.length === 0) {
    console.log("[generateAdditiveData] additives 为空，返回空对象");
    return result;
  }

  for (const add of additives) {
    console.log(`\n========== 处理添加剂: ${add.name} ==========`);

    const startAmount = add.startAmount || 0;
    const endAmount = add.endAmount || 0;
    const useMode = add.useMode || 'full';  // 'full' 或 'stage'

    console.log(
      `[generateAdditiveData] ${add.name} 起步量: ${startAmount}斤, 最终量: ${endAmount}斤, 模式: ${useMode}`
    );

    // 如果起步量和最终量都为0，跳过
    if (startAmount === 0 && endAmount === 0) {
      console.log(
        `[generateAdditiveData] ${add.name} 起步量和最终量都为0，跳过`
      );
      continue;
    }

    // ===== 计算分配区间 =====
    let effectiveStartDay;
    let effectiveEndDay;

    if (useMode === 'stage') {
      // 阶段使用模式：跟随高蛋白饲料
      if (highProteinStartDay !== null && highProteinStartDay > 0) {
        effectiveStartDay = highProteinStartDay;
      } else {
        // 没有高蛋白饲料介入，降级为全程
        effectiveStartDay = 1;
        console.log(
          `[generateAdditiveData] ⚠️ ${add.name} 阶段使用模式但未检测到高蛋白介入日，降级为全程`
        );
      }
      effectiveEndDay = peakDayForFeed;
    } else {
      // 全程模式：从第1天开始
      effectiveStartDay = 1;
      effectiveEndDay = peakDayForFeed;
    }

    // 确保开始日不超过结束日
    if (effectiveStartDay > effectiveEndDay) {
      effectiveStartDay = effectiveEndDay;
    }

    // 计算有效区间天数
    const effectiveDays = effectiveEndDay - effectiveStartDay + 1;
    console.log(
      `[generateAdditiveData] ${add.name} 有效区间: 第${effectiveStartDay}天 → 第${effectiveEndDay}天 (共${effectiveDays}天)`
    );

    // ===== 在有效区间内分配 =====
    const INTERVAL_DAYS = 5;
    let phases = [];

    if (effectiveDays <= 0) {
      phases = [];
    } else if (effectiveDays <= INTERVAL_DAYS) {
      // 区间太短，直接分配一个阶段
      phases = [{
        startDay: effectiveStartDay,
        endDay: effectiveEndDay,
        amount: Math.round(startAmount)
      }];
    } else {
      // 计算阶段数
      const phaseCount = Math.ceil(effectiveDays / INTERVAL_DAYS);
      const step = (endAmount - startAmount) / (phaseCount - 1);

      for (let i = 0; i < phaseCount; i++) {
        const amount = Math.round(startAmount + i * step);
        const startDay = effectiveStartDay + i * INTERVAL_DAYS;
        const endDay = Math.min(startDay + INTERVAL_DAYS - 1, effectiveEndDay);
        phases.push({
          startDay: startDay,
          endDay: endDay,
          amount: amount
        });
      }
    }

    console.log(
      `[generateAdditiveData] ${add.name} 计算出的阶段:`,
      JSON.stringify(phases, null, 2)
    );

    // ===== 填充每日数据 =====
    let generatedCount = 0;
    for (const phase of phases) {
      const amount = phase.amount;
      if (amount <= 0) {
        console.log(
          `[generateAdditiveData] ${add.name} 第${phase.startDay}~${phase.endDay}天用量为0，跳过`
        );
        continue;
      }

      for (
        let day = phase.startDay;
        day <= phase.endDay && day <= totalDays;
        day++
      ) {
        if (!result[day]) {
          result[day] = {};
        }
        if (result[day][add.name] !== undefined) {
          console.warn(
            `[generateAdditiveData] ⚠️ ${add.name} 第${day}天重叠！旧值: ${result[day][add.name]}, 新值: ${amount}`
          );
        }
        result[day][add.name] = amount;
        generatedCount++;
      }
    }

    // ===== 峰值日之后：保持最终量不变 =====
    const finalAmount = Math.round(endAmount);
    if (finalAmount > 0 && peakDayForFeed < totalDays) {
      for (let day = peakDayForFeed + 1; day <= totalDays; day++) {
        if (!result[day]) {
          result[day] = {};
        }
        // 如果该天已经有值，跳过（防止覆盖）
        if (result[day][add.name] === undefined) {
          result[day][add.name] = finalAmount;
          generatedCount++;
        }
      }
      console.log(
        `[generateAdditiveData] ${add.name} 峰值日后(${peakDayForFeed + 1}~${totalDays}天)保持最终量 ${finalAmount}斤`
      );
    }

    console.log(
      `[generateAdditiveData] ${add.name} 生成了 ${generatedCount} 条数据`
    );
  }

  console.log(
    "\n========== [generateAdditiveData] 生成的添加剂数据汇总 =========="
  );
  const dayKeys = Object.keys(result).sort((a, b) => parseInt(a) - parseInt(b));
  for (const day of dayKeys) {
    const feeds = result[day];
    const feedStr = Object.keys(feeds)
      .map((name) => `${name}:${feeds[name]}斤/顿`)
      .join(", ");
    console.log(`  第${day}天: ${feedStr}`);
  }
  console.log(`共生成 ${dayKeys.length} 天数据`);
  console.log("========== [generateAdditiveData] 结束 ==========\n");

  return result;
}

// ============================================================
// 体重增长算法（基于NY/T 816-2021）
// ============================================================

function getFemaleAvgADG(startWeight) {
  return 0.0056 * startWeight + 0.332;
}

function getFemaleStartADG(startWeight) {
  return 0.005 * startWeight + 0.05;
}

function getFemaleTotalDays(startWeight, targetWeight) {
  const A = getFemaleAvgADG(startWeight);
  return (targetWeight - startWeight) / A;
}

function getFemaleGrowthFactor(startWeight, targetWeight) {
  const A = getFemaleAvgADG(startWeight);
  const b = getFemaleStartADG(startWeight);
  const T = getFemaleTotalDays(startWeight, targetWeight);
  const lnT = Math.log(T);
  const denominator = T * lnT - T + 1;
  return (A * T - b * (T - 1)) / denominator;
}

function getFemaleDailyWeight(startWeight, targetWeight, t) {
  const a = getFemaleGrowthFactor(startWeight, targetWeight);
  const b = getFemaleStartADG(startWeight);
  const lnT = Math.log(t);
  const integral = t * lnT - t + 1;
  return startWeight + a * integral + b * (t - 1);
}

function getMaleAvgADG(startWeight) {
  return 0.004 * startWeight + 0.51;
}

function getMaleStartADG(startWeight) {
  return 0.0072 * startWeight + 0.048;
}

function getMaleTotalDays(startWeight, targetWeight) {
  const A = getMaleAvgADG(startWeight);
  return (targetWeight - startWeight) / A;
}

function getMaleGrowthFactor(startWeight, targetWeight) {
  const A = getMaleAvgADG(startWeight);
  const b = getMaleStartADG(startWeight);
  const T = getMaleTotalDays(startWeight, targetWeight);
  const lnT = Math.log(T);
  const denominator = T * lnT - T + 1;
  return (A * T - b * (T - 1)) / denominator;
}

function getMaleDailyWeight(startWeight, targetWeight, t) {
  const a = getMaleGrowthFactor(startWeight, targetWeight);
  const b = getMaleStartADG(startWeight);
  const lnT = Math.log(t);
  const integral = t * lnT - t + 1;
  return startWeight + a * integral + b * (t - 1);
}

// ============================================================
// 曲线分布函数 - 固定饲料分配（支持按天/按顿）
// ============================================================

function generateCurveDistribution(
  totalJin,
  totalDays,
  sheepCount,
  startWeight,
  endWeight,
  riseRatio = 0.35,
  keepRatio = 0.3,
  declineRatio = 0.35
) {
  if (totalDays <= 0) return [];

  const totalRatio = riseRatio + keepRatio + declineRatio;
  if (Math.abs(totalRatio - 1) > 0.001) {
    riseRatio = riseRatio / totalRatio;
    keepRatio = keepRatio / totalRatio;
    declineRatio = declineRatio / totalRatio;
  }

  const startPerSheep = startWeight * 0.01;
  const keepDays = Math.max(1, Math.round(totalDays * keepRatio));
  const riseDays = Math.max(1, Math.round(totalDays * riseRatio));
  const declineDays = totalDays - riseDays - keepDays;

  if (declineDays <= 0) {
    const avg = Math.round((totalJin / totalDays) * 10) / 10;
    return new Array(totalDays).fill(avg);
  }

  const startAmount = sheepCount * startPerSheep;
  const numerator = totalJin - (startAmount * riseDays) / 2;
  const denominator = riseDays / 2 + keepDays + declineDays / 2;
  let peak = numerator / denominator;
  if (peak < startAmount) peak = startAmount;

  const result = [];
  for (let i = 0; i < totalDays; i++) {
    let dailyAmount;
    if (i < riseDays) {
      const progress = i / riseDays;
      dailyAmount = startAmount + (peak - startAmount) * progress;
    } else if (i < riseDays + keepDays) {
      dailyAmount = peak;
    } else {
      const progress = (i - riseDays - keepDays) / declineDays;
      dailyAmount = peak * (1 - progress);
    }
    result.push(Math.round(dailyAmount * 10) / 10);
  }

  return result;
}

function generateCurveDistributionPerMeal(
  totalJin,
  totalMeals,
  sheepCount,
  startWeight,
  endWeight,
  riseRatio = 0.35,
  keepRatio = 0.3,
  declineRatio = 0.35
) {
  if (totalMeals <= 0) return [];

  const totalRatio = riseRatio + keepRatio + declineRatio;
  if (Math.abs(totalRatio - 1) > 0.001) {
    riseRatio = riseRatio / totalRatio;
    keepRatio = keepRatio / totalRatio;
    declineRatio = declineRatio / totalRatio;
  }

  const startPerSheep = startWeight * 0.01;
  const keepMeals = Math.max(1, Math.round(totalMeals * keepRatio));
  const riseMeals = Math.max(1, Math.round(totalMeals * riseRatio));
  const declineMeals = totalMeals - riseMeals - keepMeals;

  if (declineMeals <= 0) {
    const avg = Math.round((totalJin / totalMeals) * 10) / 10;
    return new Array(totalMeals).fill(avg);
  }

  const startAmount = sheepCount * startPerSheep;
  const numerator = totalJin - (startAmount * riseMeals) / 2;
  const denominator = riseMeals / 2 + keepMeals + declineMeals / 2;
  let peak = numerator / denominator;
  if (peak < startAmount) peak = startAmount;

  const result = [];
  for (let i = 0; i < totalMeals; i++) {
    let mealAmount;
    if (i < riseMeals) {
      const progress = i / riseMeals;
      mealAmount = startAmount + (peak - startAmount) * progress;
    } else if (i < riseMeals + keepMeals) {
      mealAmount = peak;
    } else {
      const progress = (i - riseMeals - keepMeals) / declineMeals;
      mealAmount = peak * (1 - progress);
    }
    result.push(Math.round(mealAmount * 10) / 10);
  }

  return result;
}

// ============================================================
// 蛋白变化计算函数（支持按天/按顿）
// ============================================================

function calculateDailyProteinTargets(
  totalDays,
  startProtein,
  peakProtein,
  minProtein,
  proteinPeakDay,
  minDay,
  growthStartDay
) {
  const result = [];

  const s = parseFloat(startProtein) || 18;
  const p = parseFloat(peakProtein) || 20.5;
  const m = parseFloat(minProtein) || 15.4;
  const peak = Math.min(Math.max(proteinPeakDay, 1), totalDays);
  const min = Math.min(Math.max(minDay, peak + 1), totalDays);
  const growthStart = Math.min(Math.max(growthStartDay || 1, 1), peak);

  console.log("[calculateDailyProteinTargets] 蛋白变化参数:");
  console.log(`  初始蛋白: ${s}%, 峰值蛋白: ${p}%, 最小蛋白: ${m}%`);
  console.log(
    `  增长起始日: 第${growthStart}天, 峰值日: 第${peak}天, 最小蛋白日: 第${min}天`
  );

  for (let day = 1; day <= totalDays; day++) {
    let protein;

    if (day < growthStart) {
      protein = s;
    } else if (day <= peak) {
      const progress = (day - growthStart) / (peak - growthStart || 1);
      protein = s + (p - s) * progress;
    } else if (day <= min) {
      const progress = (day - peak) / (min - peak || 1);
      protein = p - (p - m) * progress;
    } else {
      protein = m;
    }

    result.push(Math.round(protein * 1000000) / 1000000);
  }

  return result;
}

function calculateMealProteinTargets(
  totalMeals,
  startProtein,
  peakProtein,
  minProtein,
  proteinPeakMeal,
  minMeal,
  growthStartMeal
) {
  const result = [];

  const s = parseFloat(startProtein) || 18;
  const p = parseFloat(peakProtein) || 20.5;
  const m = parseFloat(minProtein) || 15.4;
  const peak = Math.min(Math.max(proteinPeakMeal, 1), totalMeals);
  const min = Math.min(Math.max(minMeal, peak + 1), totalMeals);
  const growthStart = Math.min(Math.max(growthStartMeal || 1, 1), peak);

  console.log("[calculateMealProteinTargets] 按顿蛋白变化参数:");
  console.log(`  初始蛋白: ${s}%, 峰值蛋白: ${p}%, 最小蛋白: ${m}%`);
  console.log(
    `  增长起始顿: 第${growthStart}顿, 峰值顿: 第${peak}顿, 最小蛋白顿: 第${min}顿`
  );

  for (let mealIdx = 1; mealIdx <= totalMeals; mealIdx++) {
    let protein;

    if (mealIdx < growthStart) {
      protein = s;
    } else if (mealIdx <= peak) {
      const progress = (mealIdx - growthStart) / (peak - growthStart || 1);
      protein = s + (p - s) * progress;
    } else if (mealIdx <= min) {
      const progress = (mealIdx - peak) / (min - peak || 1);
      protein = p - (p - m) * progress;
    } else {
      protein = m;
    }

    result.push(Math.round(protein * 1000000) / 1000000);
  }

  return result;
}

function calculateProteinPeakDay(fixedFeeds, fullCourseFeeds) {
  let earliestPeakDay = Infinity;
  let earliestGrowthStartDay = Infinity;
  let hasHighProteinFeed = false;

  if (fixedFeeds && fixedFeeds.length > 0) {
    for (const feed of fixedFeeds) {
      const startDay = feed.startDay || 1;
      const endDay = feed.endDay || 1;
      const protein = parseFloat(feed.protein) || 0;
      const totalDays = endDay - startDay + 1;
      const riseDays = Math.max(1, Math.round(totalDays * 0.45));
      const keepDays = Math.max(1, Math.round(totalDays * 0.3));
      const peakDay = startDay + riseDays + keepDays - 2;

      if (peakDay < earliestPeakDay) {
        earliestPeakDay = peakDay;
      }

      if (protein > 18) {
        hasHighProteinFeed = true;
        if (startDay < earliestGrowthStartDay) {
          earliestGrowthStartDay = startDay;
        }
      }
    }
  }

  if (fullCourseFeeds && fullCourseFeeds.length > 0) {
    for (const feed of fullCourseFeeds) {
      const startDay = feed.startDay || 1;
      const protein = parseFloat(feed.protein) || 0;

      if (protein > 18) {
        hasHighProteinFeed = true;
        if (startDay < earliestGrowthStartDay) {
          earliestGrowthStartDay = startDay;
        }
      }
    }
  }

  const growthStartDay = hasHighProteinFeed ? earliestGrowthStartDay : 1;
  const peakDay = earliestPeakDay === Infinity ? 1 : earliestPeakDay;

  console.log("[calculateProteinPeakDay] 结果:");
  console.log(`  蛋白峰值日: 第${peakDay}天`);
  console.log(
    `  蛋白增长起始日: 第${growthStartDay}天${
      hasHighProteinFeed
        ? " (检测到蛋白>18%的饲料)"
        : " (无高蛋白饲料，从第1天开始)"
    }`
  );

  return { peakDay, growthStartDay };
}

function calculateProteinPeakMeal(fixedFeeds, fullCourseFeeds) {
  const { peakDay, growthStartDay } = calculateProteinPeakDay(
    fixedFeeds,
    fullCourseFeeds
  );
  const peakMeal = (peakDay - 1) * 2 + 1;
  const growthStartMeal = (growthStartDay - 1) * 2 + 1;

  return { peakMeal, growthStartMeal };
}

// ============================================================
// 高蛋白饲料组合函数
// ============================================================

function getHighProteinCombination(
  proteinFeeds,
  highProteinStartRatios,
  highProteinEndRatios,
  totalDays,
  peakDay
) {
  if (!proteinFeeds || proteinFeeds.length === 0) {
    return null;
  }

  const highProteinFeeds = proteinFeeds.filter((f) => {
    const protein = parseFloat(f.protein) || 0;
    const isFixed = f.endDay !== null && f.endDay !== undefined && f.endDay > 0;
    return protein >= 30 && !isFixed;
  });

  if (highProteinFeeds.length === 0) {
    return null;
  }

  if (highProteinFeeds.length === 1) {
    const feed = highProteinFeeds[0];
    return {
      name: feed.name,
      protein: parseFloat(feed.protein) || 0,
      price: parseFloat(feed.price) || 0,
      startDay: feed.startDay || 1,
      isSingle: true,
      singleFeed: feed,
    };
  }

  let allValid = true;
  const startRatios = {};
  const endRatios = {};

  for (const f of highProteinFeeds) {
    const startRatio = parseFloat(highProteinStartRatios?.[f.name]) || 0;
    const endRatio = parseFloat(highProteinEndRatios?.[f.name]) || 0;
    startRatios[f.name] = startRatio;
    endRatios[f.name] = endRatio;
    if (startRatio <= 0 || endRatio <= 0) {
      allValid = false;
    }
  }

  if (!allValid) {
    console.error(
      "[getHighProteinCombination] 高蛋白饲料前期或后期比例未完全设置"
    );
    return null;
  }

  const stableDay = peakDay;

  console.log("[getHighProteinCombination] 高蛋白饲料配比逻辑:");
  console.log(`  稳定日: 第${stableDay}天`);

  const feedInfoList = highProteinFeeds.map((f) => {
    const name = f.name;
    const startDay = f.startDay || 1;
    const startRatio = startRatios[name] || 0;
    const endRatio = endRatios[name] || 0;
    const protein = parseFloat(f.protein) || 0;
    const price = parseFloat(f.price) || 0;
    const duration = stableDay - startDay;
    const dailyChange = duration > 0 ? (endRatio - startRatio) / duration : 0;

    console.log(
      `  ${name}: 第${startDay}天开始, 配比从${startRatio}到${endRatio}, 每天变化${dailyChange.toFixed(
        6
      )}`
    );

    return {
      name,
      startDay,
      startRatio,
      endRatio,
      protein,
      price,
      rawFeed: f,
      dailyChange: dailyChange,
      duration: duration,
    };
  });

  const allReadyDay = Math.max(...feedInfoList.map((f) => f.startDay));

  function getRatiosForDay(day) {
    const rawRatios = {};
    const startedStatus = {};
    let totalRawRatio = 0;

    console.log(
      `[getRatiosForDay] ===== 第${day}天, 到齐日=${allReadyDay} =====`
    );

    for (const info of feedInfoList) {
      let ratio = 0;
      const isStarted = day >= info.startDay;

      if (!isStarted) {
        ratio = 0;
        startedStatus[info.name] = false;
        console.log(
          `  ${info.name}: 第${day}天 < 开始日${info.startDay}，配比=0 (未开始)`
        );
      } else if (day >= stableDay) {
        ratio = info.endRatio;
        startedStatus[info.name] = true;
        console.log(
          `  ${
            info.name
          }: 第${day}天 >= 稳定日${stableDay}，配比=${ratio.toFixed(4)}`
        );
      } else if (day < allReadyDay) {
        ratio = info.startRatio;
        startedStatus[info.name] = true;
        console.log(
          `  ${
            info.name
          }: 第${day}天 < 到齐日${allReadyDay}，保持起始配比${ratio.toFixed(
            4
          )} (等待其他饲料)`
        );
      } else {
        const progress = (day - allReadyDay) / (stableDay - allReadyDay || 1);
        ratio = info.startRatio + (info.endRatio - info.startRatio) * progress;
        ratio = Math.max(0, ratio);
        startedStatus[info.name] = true;
        console.log(
          `  ${
            info.name
          }: 第${day}天 >= 到齐日${allReadyDay}，progress=${progress.toFixed(
            4
          )}，配比=${ratio.toFixed(4)}`
        );
      }

      rawRatios[info.name] = ratio;
      if (ratio > 0) {
        totalRawRatio += ratio;
      }
    }

    console.log(`[getRatiosForDay] 原始配比总和: ${totalRawRatio.toFixed(4)}`);

    const normalized = {};
    if (totalRawRatio > 0) {
      for (const info of feedInfoList) {
        const rawRatio = rawRatios[info.name] || 0;
        if (rawRatio > 0) {
          normalized[info.name] = rawRatio / totalRawRatio;
          console.log(
            `  ${info.name} 归一化后: ${normalized[info.name].toFixed(4)} (${(
              normalized[info.name] * 100
            ).toFixed(2)}%)`
          );
        } else {
          normalized[info.name] = 0;
          console.log(`  ${info.name} 归一化后: 0.0000 (0.00%) - 未开始`);
        }
      }
    } else {
      for (const info of feedInfoList) {
        normalized[info.name] = 0;
      }
      console.log(`  ⚠️ 所有配比都为0，归一化失败`);
    }

    console.log(`[getRatiosForDay] ===== 结束 =====`);

    return {
      ratios: normalized,
      startedStatus: startedStatus,
    };
  }

  function getWeightedValues(day) {
    const result = getRatiosForDay(day);
    const ratios = result.ratios;
    const startedStatus = result.startedStatus;

    let totalProtein = 0;
    let totalPrice = 0;
    let totalRatioForActive = 0;

    for (const info of feedInfoList) {
      if (!startedStatus[info.name]) continue;
      const ratio = ratios[info.name] || 0;
      if (ratio <= 0) continue;
      totalRatioForActive += ratio;
      totalProtein += ratio * info.protein;
      totalPrice += ratio * info.price;
    }

    const normalizedProtein =
      totalRatioForActive > 0 ? totalProtein / totalRatioForActive : 0;
    const normalizedPrice =
      totalRatioForActive > 0 ? totalPrice / totalRatioForActive : 0;

    return {
      protein: Math.round(normalizedProtein * 10) / 10,
      price: Math.round(normalizedPrice * 100) / 100,
      ratios: ratios,
      startedStatus: startedStatus,
    };
  }

  const stableValues = getWeightedValues(stableDay);

  return {
    name: "高蛋白组合",
    startProtein: stableValues.protein,
    endProtein: stableValues.protein,
    startPrice: stableValues.price,
    endPrice: stableValues.price,
    startBaseDay: Math.max(...feedInfoList.map((f) => f.startDay)),
    peakDay: peakDay,
    stableDay: stableDay,
    isCombination: true,
    feedInfoList: feedInfoList,
    allReadyDay: allReadyDay,
    getRatiosForDay: getRatiosForDay,
    getWeightedValues: getWeightedValues,
    feeds: highProteinFeeds.map((f) => ({
      name: f.name,
      protein: parseFloat(f.protein) || 0,
      price: parseFloat(f.price) || 0,
      startDay: f.startDay || 1,
      startRatio: startRatios[f.name] || 0,
      endRatio: endRatios[f.name] || 0,
    })),
    daysDiff: stableDay - Math.max(...feedInfoList.map((f) => f.startDay)),
  };
}

// ============================================================
// 国标模式主函数（支持按天/按顿）- 完整实现
// ============================================================

function generateNationalPlan(params) {
  const {
    sheepCount,
    targetDay,
    lambType,
    startWeight,
    targetOutWeight,
    proteinFeeds,
    additives,
    batchSheepCount,
    startProtein = 18,
    peakProtein = 20.5,
    minProtein = 15.4,
    highProteinStartRatios = {},
    highProteinEndRatios = {},
    feedGranularity = "day",
    maxFeedPerMeal = 0,
    proteinAtMaxFeed = 0,
    highProteinFixedStartAmount = null,
    lowProteinFixedStartAmount = null,
    proteinMinDayPercent = 85,
    feedPeakDayPercent = 90,
  } = params;

  console.log("[generateNationalPlan] 接收到的参数:");
  console.log(`  sheepCount: ${sheepCount}, lambType: ${lambType}`);
  console.log(
    `  startWeight: ${startWeight}, targetOutWeight: ${targetOutWeight}`
  );
  console.log(`  feedGranularity: ${feedGranularity}`);
  console.log(`  proteinFeeds: ${proteinFeeds.map((f) => f.name).join(", ")}`);
  console.log(`  additives: ${additives.map((a) => a.name).join(", ")}`);
  console.log(`  maxFeedPerMeal: ${maxFeedPerMeal}`);
  console.log(`  proteinAtMaxFeed: ${proteinAtMaxFeed}`);
  console.log(`  feedPeakDayPercent: ${feedPeakDayPercent}`);
  console.log(`  proteinMinDayPercent: ${proteinMinDayPercent}`);

  console.log("===== proteinFeeds 详细数据 =====");
  for (const f of proteinFeeds) {
    console.log(`  ${f.name}: protein=${f.protein}, totalTons=${f.totalTons}, startDay=${f.startDay}, endDay=${f.endDay}, totalTonsDisplay=${f.totalTonsDisplay}, endDayDisplay=${f.endDayDisplay}`);
  }
  console.log("===================================");

  const validStartWeight = parseFloat(startWeight);
  if (isNaN(validStartWeight) || validStartWeight <= 0) {
    console.error("[generateNationalPlan] 进圈斤数无效:", startWeight);
    return {
      success: false,
      error: `进圈斤数无效：${startWeight}，请输入有效的数字`,
    };
  }

  const actualSheepCount = sheepCount || batchSheepCount || 200;

  const isFemale = lambType === "female";
  const getWeight = isFemale ? getFemaleDailyWeight : getMaleDailyWeight;
  const getTotalDays = isFemale ? getFemaleTotalDays : getMaleTotalDays;

  let days = targetDay;
  if (!days || days <= 0) {
    days = Math.ceil(getTotalDays(validStartWeight, targetOutWeight));
  }
  days = Math.min(150, Math.max(1, days));

  const feedArray = generateFixedFeedArray(
    days,
    lambType,
    validStartWeight,
    feedGranularity
  );

  if (!feedArray || feedArray.length === 0) {
    console.error("[generateNationalPlan] 生成配料数据失败");
    return { success: false, error: "生成配料数据失败，请检查配置" };
  }

  if (maxFeedPerMeal > 0 && feedArray && feedArray.length > 0) {
    const peakDay = Math.floor(days * (feedPeakDayPercent / 100));
    const startFeed = feedArray[0].feedPerMeal;
    const peakFeed = maxFeedPerMeal;

    for (let i = 0; i < feedArray.length; i++) {
      const day = i + 1;
      if (day <= peakDay) {
        const progress = (day - 1) / (peakDay - 1 || 1);
        feedArray[i].feedPerMeal = parseFloat(
          (startFeed + (peakFeed - startFeed) * progress).toFixed(4)
        );
        feedArray[i].feedPerDay = parseFloat(
          (feedArray[i].feedPerMeal * 2).toFixed(2)
        );
      } else {
        feedArray[i].feedPerMeal = peakFeed;
        feedArray[i].feedPerDay = parseFloat((peakFeed * 2).toFixed(2));
      }
    }

    console.log(
      `[generateNationalPlan] 应用自定义最大采食量: ${peakFeed}斤/顿, 峰值日百分比: ${feedPeakDayPercent}%`
    );
  }

  const effectiveMinProtein =
    proteinAtMaxFeed > 0 ? proteinAtMaxFeed : minProtein;

  const peakDay = Math.floor(days * (feedPeakDayPercent / 100));

  const highProteinCombination = getHighProteinCombination(
    proteinFeeds,
    highProteinStartRatios,
    highProteinEndRatios,
    days,
    peakDay
  );

  if (highProteinCombination === null) {
    const highProteinFeeds = proteinFeeds.filter((f) => {
      const protein = parseFloat(f.protein) || 0;
      const isFixed =
        f.endDay !== null && f.endDay !== undefined && f.endDay > 0;
      return protein >= 30 && !isFixed;
    });
    if (highProteinFeeds.length > 1) {
      return {
        success: false,
        error:
          "高蛋白饲料（蛋白≥30%）前期或后期比例未完全设置或无效，请检查搭配比例设置",
      };
    }
  }

  const dailyResults = [];
  for (let day = 1; day <= days; day++) {
    const weight = getWeight(validStartWeight, targetOutWeight, day);
    let validWeight = weight;
    if (isNaN(weight) || weight <= 0) {
      if (day === 1) {
        validWeight = validStartWeight;
      } else {
        const avgADG = (targetOutWeight - validStartWeight) / days;
        validWeight = validStartWeight + (day - 1) * avgADG;
      }
    }

    const feedData = feedArray[day - 1] || feedArray[0];

    dailyResults.push({
      day: day,
      weight: Math.round(validWeight * 10) / 10,
      feedPerMeal: feedData.feedPerMeal || 0,
      targetProtein: feedData.targetProtein || 18,
      isStable: feedData.isStable || false,
    });
  }

  const fixedFeedsForPlan = proteinFeeds.filter((f) => {
    const endDay = f.endDay;
    const protein = parseFloat(f.protein) || 0;
    return protein > 0 && protein <= 20 && f.totalTons && f.totalTons > 0;
  });

  const sortedFixedFeeds = [...fixedFeedsForPlan].sort((a, b) => {
    const startA = a.startDay || 1;
    const startB = b.startDay || 1;
    return startA - startB;
  });

  console.log(
    "[generateNationalPlan] 固定饲料（独立分配）:",
    sortedFixedFeeds.map(
      (f) => `${f.name}(蛋白${f.protein}%, ${f.startDay || 1}~${f.endDay}天)`
    )
  );

  const fixedDailyTargets = {};
  let isFirstFixedFeedAssigned = false;

  for (const feed of sortedFixedFeeds) {
    const totalJin = feed.totalTons * 2000;
    const startDay = feed.startDay || 1;
    const endDay = feed.endDay || days;
    const totalPeriod = endDay - startDay + 1;

    const feedProtein = parseFloat(feed.protein) || 0;

    let startAmountPerSheepPerDay;

    if (!isFirstFixedFeedAssigned) {
      if (feedProtein >= 18) {
        if (highProteinFixedStartAmount !== null && highProteinFixedStartAmount > 0) {
          startAmountPerSheepPerDay = highProteinFixedStartAmount;
        } else {
          startAmountPerSheepPerDay = 0.2;
        }
        console.log(
          `[固定饲料] ${feed.name} 首个高蛋白固定饲料(蛋白${feedProtein}%)，起步量: ${startAmountPerSheepPerDay} 斤/只/天`
        );
      } else {
        if (lowProteinFixedStartAmount !== null && lowProteinFixedStartAmount > 0) {
          startAmountPerSheepPerDay = lowProteinFixedStartAmount;
        } else {
          startAmountPerSheepPerDay = 0.3;
        }
        console.log(
          `[固定饲料] ${feed.name} 首个低蛋白固定饲料(蛋白${feedProtein}%)，起步量: ${startAmountPerSheepPerDay} 斤/只/天`
        );
      }
      isFirstFixedFeedAssigned = true;
    } else {
      startAmountPerSheepPerDay = 0.02;
      console.log(
        `[固定饲料] ${feed.name} 非首个固定饲料，起步量: ${startAmountPerSheepPerDay} 斤/只/天`
      );
    }

    let startWeightParam;
    let actualStartPerSheep;

    if (feedGranularity === "meal") {
      const startAmountPerSheepPerMeal = startAmountPerSheepPerDay / 2;
      startWeightParam = startAmountPerSheepPerMeal * 100;
      actualStartPerSheep = startAmountPerSheepPerMeal;
      console.log(
        `[固定饲料] 按顿模式: ${feed.name} 每天${startAmountPerSheepPerDay}斤/天 → 每顿${startAmountPerSheepPerMeal}斤/顿`
      );
    } else {
      startWeightParam = startAmountPerSheepPerDay * 100;
      actualStartPerSheep = startAmountPerSheepPerDay;
    }

    let dailyWeights;
    if (feedGranularity === "meal") {
      const totalMealsCount = totalPeriod * 2;
      dailyWeights = generateCurveDistributionPerMeal(
        totalJin,
        totalMealsCount,
        actualSheepCount,
        startWeightParam,
        targetOutWeight
      );
    } else {
      dailyWeights = generateCurveDistribution(
        totalJin,
        totalPeriod,
        actualSheepCount,
        startWeightParam,
        targetOutWeight
      );
    }

    fixedDailyTargets[feed.name] = {
      feed: feed,
      startDay: startDay,
      endDay: endDay,
      dailyWeights: dailyWeights,
      granularity: feedGranularity,
    };

    console.log(
      `[固定饲料] ${feed.name}: 蛋白${feedProtein}%, 传入值${startWeightParam}, 实际起步量${actualStartPerSheep.toFixed(3)}斤/只/${feedGranularity === "meal" ? "顿" : "天"}, 第${startDay}~${endDay}天, 曲线长度${dailyWeights.length}`
    );
  }

  console.log("========== 固定饲料分配结果（前3天） ==========");
  for (const name in fixedDailyTargets) {
    const plan = fixedDailyTargets[name];
    const weights = plan.dailyWeights;
    console.log(
      `${name}: 第1天${weights[0] || 0}斤, 第2天${weights[1] || 0}斤, 第3天${
        weights[2] || 0
      }斤`
    );
  }
  console.log("===============================================");

  const fullCourseFeeds = proteinFeeds.filter((f) => {
    const endDay = f.endDay;
    const protein = parseFloat(f.protein) || 0;
    return (
      protein > 0 &&
      (endDay === null ||
        endDay === undefined ||
        endDay === "" ||
        endDay === "0" ||
        Number(endDay) === 0)
    );
  });

  let fullCourseList = [...fullCourseFeeds];

  if (highProteinCombination && highProteinCombination.isCombination) {
    const highProteinNames = highProteinCombination.feeds.map((f) => f.name);
    fullCourseList = fullCourseList.filter(
      (f) => !highProteinNames.includes(f.name)
    );

    const combinationFeeds = highProteinCombination.feedInfoList.map(
      (subFeed) => ({
        name: subFeed.name,
        protein: subFeed.protein || 0,
        price: subFeed.price || 0,
        startDay: subFeed.startDay || 1,
        startRatio: subFeed.startRatio || 0,
        endRatio: subFeed.endRatio || 0,
        ratio: subFeed.startRatio || 0,
        isStarted: false,
      })
    );

    fullCourseList.push({
      name: highProteinCombination.name,
      protein: highProteinCombination.startProtein,
      price: highProteinCombination.startPrice || 0,
      isCombination: true,
      combinationFeeds: combinationFeeds,
      feedInfoList: highProteinCombination.feedInfoList,
      getRatiosForDay: highProteinCombination.getRatiosForDay,
      getWeightedValues: highProteinCombination.getWeightedValues,
      allReadyDay: highProteinCombination.allReadyDay,
      startBaseDay: highProteinCombination.startBaseDay,
      peakDay: highProteinCombination.peakDay,
      startProtein: highProteinCombination.startProtein,
      endProtein: highProteinCombination.endProtein,
      startPrice: highProteinCombination.startPrice,
      endPrice: highProteinCombination.endPrice,
      daysDiff: highProteinCombination.daysDiff,
      rawFeeds: highProteinCombination.feeds,
      granularity: feedGranularity,
    });

    console.log(
      "[generateNationalPlan] 高蛋白组合已添加到全程饲料列表:",
      combinationFeeds.map((f) => `${f.name}(配比${f.startRatio})`).join(", ")
    );
  } else if (highProteinCombination && highProteinCombination.isSingle) {
    const existing = fullCourseList.find(
      (f) => f.name === highProteinCombination.name
    );
    if (existing && !existing.startDay) {
      existing.startDay = highProteinCombination.startDay || 1;
    }
  }

  let highProteinFullCourseStartDay = null;
  const sortedFullCourseForCheck = proteinFeeds
    .filter((f) => {
      const protein = parseFloat(f.protein) || 0;
      const endDay = f.endDay;
      const isFullCourse =
        endDay === null ||
        endDay === undefined ||
        endDay === "" ||
        endDay === "0" ||
        Number(endDay) === 0;
      return (
        protein > 18 &&
        isFullCourse &&
        f.startDay !== undefined &&
        f.startDay !== null &&
        f.startDay > 1
      );
    })
    .sort((a, b) => (a.startDay || 1) - (b.startDay || 1));

  if (sortedFullCourseForCheck.length > 0) {
    highProteinFullCourseStartDay = sortedFullCourseForCheck[0].startDay || 1;
    console.log(
      "[generateNationalPlan] ✅ 检测到蛋白>18%的全程饲料介入日:",
      highProteinFullCourseStartDay,
      "（饲料：",
      sortedFullCourseForCheck.map((f) => f.name).join(", "),
      "）"
    );
  } else {
    console.log(
      "[generateNationalPlan] ⚠️ 未检测到蛋白>18%的全程饲料（从原始 proteinFeeds 中检测）"
    );
  }

  const fixedFeedsForProteinPeak = proteinFeeds.filter((f) => {
    const protein = parseFloat(f.protein) || 0;
    return (
      protein > 0 && f.endDay !== null && f.endDay !== undefined && f.endDay > 0
    );
  });

  const fullCourseFeedsForProteinPeak = proteinFeeds.filter((f) => {
    const protein = parseFloat(f.protein) || 0;
    return (
      protein > 0 &&
      (f.endDay === null ||
        f.endDay === undefined ||
        f.endDay === "" ||
        f.endDay === "0" ||
        Number(f.endDay) === 0)
    );
  });

  const { peakDay: originalPeakDay, growthStartDay: originalGrowthStartDay } =
    calculateProteinPeakDay(
      fixedFeedsForProteinPeak,
      fullCourseFeedsForProteinPeak
    );

  let actualGrowthStartDay;
  let useNewLogic = false;
  let finalProteinPeakDay;

  if (
    highProteinFullCourseStartDay !== null &&
    highProteinFullCourseStartDay >= 2
  ) {
    actualGrowthStartDay = highProteinFullCourseStartDay;
    useNewLogic = true;
    const remainingDays = days - actualGrowthStartDay;
    finalProteinPeakDay = Math.round(
      actualGrowthStartDay + remainingDays * 0.3
    );
    finalProteinPeakDay = Math.min(
      Math.max(finalProteinPeakDay, actualGrowthStartDay),
      days
    );
    console.log(
      "[generateNationalPlan] 🎯 使用新逻辑: 增长起始日 = 第",
      actualGrowthStartDay,
      "天"
    );
    console.log(
      `  ⭐ 蛋白峰值日 = ${actualGrowthStartDay} + (${days} - ${actualGrowthStartDay}) × 30% = ${finalProteinPeakDay} 天`
    );
  } else {
    actualGrowthStartDay = originalGrowthStartDay;
    finalProteinPeakDay = originalPeakDay;
    console.log(
      "[generateNationalPlan] 使用原逻辑: 增长起始日 = 第",
      actualGrowthStartDay,
      "天, 峰值日 = 第",
      finalProteinPeakDay,
      "天"
    );
  }

  const minDay = Math.round(days * (proteinMinDayPercent / 100));

  let dailyProteinTargets;
  const totalMeals = days * 2;

  if (feedGranularity === "meal") {
    const growthStartMeal = (actualGrowthStartDay - 1) * 2 + 1;
    const totalMealsCount = days * 2;
    const peakMeal = Math.round(
      growthStartMeal + (totalMealsCount - growthStartMeal) * 0.3
    );
    const finalPeakMeal = Math.min(
      Math.max(peakMeal, growthStartMeal),
      totalMealsCount
    );
    const minMeal = minDay * 2;
    dailyProteinTargets = calculateMealProteinTargets(
      totalMeals,
      startProtein,
      peakProtein,
      effectiveMinProtein,
      finalPeakMeal,
      minMeal,
      growthStartMeal
    );
    console.log(
      `[generateNationalPlan] 📊 按顿模式: 增长起始顿=${growthStartMeal}, 峰值顿=${finalPeakMeal}, 最小蛋白顿=${minMeal}`
    );
  } else {
    dailyProteinTargets = calculateDailyProteinTargets(
      days,
      startProtein,
      peakProtein,
      effectiveMinProtein,
      finalProteinPeakDay,
      minDay,
      actualGrowthStartDay
    );
    console.log(
      `[generateNationalPlan] 📊 按天模式: 增长起始日=${actualGrowthStartDay}, 峰值日=${finalProteinPeakDay}, 最小蛋白日=${minDay}`
    );
  }

  console.log("[generateNationalPlan] 📈 蛋白目标值预览（前20天）:");
  for (let day = 1; day <= Math.min(20, days); day++) {
    const idx = feedGranularity === "meal" ? (day - 1) * 2 : day - 1;
    const val = dailyProteinTargets[idx] || 0;
    console.log(`  第${day}天: ${val.toFixed(2)}%`);
  }

  console.log("[generateNationalPlan] 蛋白变化参数汇总:");
  console.log(`  蛋白峰值日: 第${finalProteinPeakDay}天`);
  console.log(`  增长起始日: 第${actualGrowthStartDay}天`);
  console.log(`  最小蛋白日: 第${minDay}天`);
  console.log(`  后期稳定蛋白: ${effectiveMinProtein}%`);
  console.log(`  是否使用新逻辑: ${useNewLogic ? "✅ 是" : "❌ 否"}`);

  const baseDay = actualGrowthStartDay;
  const baseMeal = (baseDay - 1) * 2 + 1;

  function calculateFixedTotalForMeal(mealIdx) {
    const day = Math.floor((mealIdx - 1) / 2) + 1;
    let total = 0;
    for (const name in fixedDailyTargets) {
      const plan = fixedDailyTargets[name];
      if (day >= plan.startDay && day <= plan.endDay) {
        if (plan.granularity === "meal") {
          const idx = mealIdx - 1;
          if (idx >= 0 && idx < plan.dailyWeights.length) {
            total += plan.dailyWeights[idx];
          }
        } else {
          const idx = day - plan.startDay;
          if (idx >= 0 && idx < plan.dailyWeights.length) {
            total += plan.dailyWeights[idx] / 2;
          }
        }
      }
    }
    return Math.round(total * 10) / 10;
  }

  function calculateFixedTotalForDay(day) {
    let total = 0;
    for (const name in fixedDailyTargets) {
      const plan = fixedDailyTargets[name];
      if (day >= plan.startDay && day <= plan.endDay) {
        const idx = day - plan.startDay;
        if (idx >= 0 && idx < plan.dailyWeights.length) {
          total += plan.dailyWeights[idx] / 2;
        }
      }
    }
    return Math.round(total * 10) / 10;
  }

  let baseFixedTotal;
  if (feedGranularity === "meal") {
    baseFixedTotal = calculateFixedTotalForMeal(baseMeal);
    console.log("[generateNationalPlan] 按顿模式基准日设置:");
    console.log(`  增长起始日: 第${baseDay}天, 对应第${baseMeal}顿`);
    console.log(`  基准顿固定饲料总量: ${baseFixedTotal}斤/顿`);
  } else {
    baseFixedTotal = calculateFixedTotalForDay(baseDay);
    console.log("[generateNationalPlan] 按天模式基准日设置:");
    console.log(`  增长起始日: 第${baseDay}天`);
    console.log(`  基准日固定饲料总量: ${baseFixedTotal}斤/顿`);
  }

  let baseFixedTotalForGrowth = baseFixedTotal;

  if (useNewLogic && baseDay >= 2) {
    const prevDay = baseDay - 1;
    let prevDayFixedTotal;
    if (feedGranularity === "meal") {
      const prevMeal = (prevDay - 1) * 2 + 1;
      prevDayFixedTotal = calculateFixedTotalForMeal(prevMeal);
    } else {
      prevDayFixedTotal = calculateFixedTotalForDay(prevDay);
    }

    if (prevDayFixedTotal > 0) {
      baseFixedTotalForGrowth = prevDayFixedTotal;
      console.log(
        `[generateNationalPlan] 新逻辑: 使用第${prevDay}天的固定饲料总量 ${prevDayFixedTotal} 斤/顿作为增长起点`
      );
    } else {
      console.log(
        `[generateNationalPlan] 新逻辑: 第${prevDay}天没有固定饲料，使用基准值 ${baseFixedTotal} 斤/顿`
      );
    }
  }

  const totalMealsCount = days * 2;
  const mealPlan = [];

  const targetPerMealArray = [];
  if (feedGranularity === "meal") {
    for (let mealIdx = 0; mealIdx < totalMealsCount; mealIdx++) {
      const feedData = feedArray[mealIdx] || feedArray[0];
      targetPerMealArray.push(feedData.feedPerMeal || 0);
    }
  } else {
    for (let day = 1; day <= days; day++) {
      const feedData = feedArray[day - 1] || feedArray[0];
      const value = feedData.feedPerMeal || 0;
      targetPerMealArray.push(value);
      targetPerMealArray.push(value);
    }
  }

  const peakDayForFeed = Math.floor(days * (feedPeakDayPercent / 100));
  const peakMealForFeed = (peakDayForFeed - 1) * 2 + 1;
  const peakPerSheep = targetPerMealArray[peakMealForFeed - 1] || 1.2;
  const peakTotal = peakPerSheep * actualSheepCount;

  console.log("[generateNationalPlan] 峰值设置:");
  console.log(
    `  峰值日: 第${peakDayForFeed}天, 峰值顿: 第${peakMealForFeed}顿`
  );
  console.log(`  峰值采食量: ${peakPerSheep}斤/只/顿 (总计 ${peakTotal}斤/顿)`);

  let dailyGrowth;
  if (feedGranularity === "meal") {
    const startMeal = (baseDay - 1) * 2 + 1;
    const mealDiff = peakMealForFeed - startMeal;
    dailyGrowth =
      mealDiff > 0 ? (peakTotal - baseFixedTotalForGrowth) / mealDiff : 0;
    console.log(
      `  增长起点顿: 第${startMeal}顿, 起点值: ${baseFixedTotalForGrowth}斤/顿`
    );
    console.log(
      `  到峰值顿(第${peakMealForFeed}顿)需要增长: ${
        peakTotal - baseFixedTotalForGrowth
      }斤/顿`
    );
    console.log(`  每顿增长: ${dailyGrowth.toFixed(6)}斤/顿`);
  } else {
    const dayDiff = peakDayForFeed - baseDay;
    dailyGrowth =
      dayDiff > 0 ? (peakTotal - baseFixedTotalForGrowth) / dayDiff : 0;
    console.log(
      `  增长起点日: 第${baseDay}天, 起点值: ${baseFixedTotalForGrowth}斤/顿`
    );
    console.log(
      `  到峰值日(第${peakDayForFeed}天)需要增长: ${
        peakTotal - baseFixedTotalForGrowth
      }斤/顿`
    );
    console.log(`  每天增长: ${dailyGrowth.toFixed(6)}斤/顿/天`);
  }

  for (let mealIdx = 0; mealIdx < totalMealsCount; mealIdx++) {
    const day = Math.floor(mealIdx / 2) + 1;
    const isMorning = mealIdx % 2 === 0;
    const dayData = dailyResults[day - 1];

    let currentConcentrateTotal;

    if (feedGranularity === "meal") {
      const currentMealIndex = mealIdx + 1;
      if (currentMealIndex < baseMeal) {
        currentConcentrateTotal =
          targetPerMealArray[mealIdx] * actualSheepCount;
      } else if (currentMealIndex <= peakMealForFeed) {
        currentConcentrateTotal =
          baseFixedTotalForGrowth + (currentMealIndex - baseMeal) * dailyGrowth;
      } else {
        currentConcentrateTotal = peakTotal;
      }
      currentConcentrateTotal = Math.max(0, currentConcentrateTotal);
    } else {
      if (day < baseDay) {
        currentConcentrateTotal =
          targetPerMealArray[mealIdx] * actualSheepCount;
      } else if (day <= peakDayForFeed) {
        currentConcentrateTotal =
          baseFixedTotalForGrowth + (day - baseDay) * dailyGrowth;
      } else {
        currentConcentrateTotal = peakTotal;
      }
      currentConcentrateTotal = Math.max(0, currentConcentrateTotal);
    }

    let targetProtein;
    if (feedGranularity === "meal") {
      targetProtein = dailyProteinTargets[mealIdx] || 18;
    } else {
      targetProtein = dailyProteinTargets[day - 1] || 18;
    }

    const fixedFeedsForMeal = [];
    let fixedTotalThisMeal = 0;
    let fixedProteinThisMeal = 0;

    for (const name in fixedDailyTargets) {
      const plan = fixedDailyTargets[name];
      if (day >= plan.startDay && day <= plan.endDay) {
        let perMealTarget = 0;

        if (plan.granularity === "meal") {
          const offset = (plan.startDay - 1) * 2;
          const idx = mealIdx - offset;
          if (idx >= 0 && idx < plan.dailyWeights.length) {
            perMealTarget = plan.dailyWeights[idx];
          }
        } else {
          const idx = day - plan.startDay;
          if (idx >= 0 && idx < plan.dailyWeights.length) {
            perMealTarget = plan.dailyWeights[idx] / 2;
          }
        }

        perMealTarget = Math.round(perMealTarget * 10) / 10;
        if (perMealTarget < 0) perMealTarget = 0;

        if (perMealTarget > 0) {
          fixedFeedsForMeal.push({
            name: name,
            perMealTarget: perMealTarget,
            protein: plan.feed.protein || 0,
            price: plan.feed.price || 0,
          });
          fixedTotalThisMeal += perMealTarget;
          fixedProteinThisMeal += perMealTarget * (plan.feed.protein / 100);
        }
      }
    }

    let neededPerMeal = currentConcentrateTotal - fixedTotalThisMeal;
    if (neededPerMeal < 0) neededPerMeal = 0;

    const totalProteinTargetPerMeal =
      currentConcentrateTotal * (targetProtein / 100);
    const neededProteinPerMeal =
      totalProteinTargetPerMeal - fixedProteinThisMeal;

    let fullCourseTargetProtein = 0;
    if (neededPerMeal > 0 && neededProteinPerMeal > 0) {
      fullCourseTargetProtein = (neededProteinPerMeal / neededPerMeal) * 100;
      fullCourseTargetProtein = Math.min(
        Math.max(fullCourseTargetProtein, 0),
        100
      );
    }

    const allFeeds = [];
    let totalAmount = 0;
    let totalProteinWeight = 0;
    let totalProtein = 0;

    for (const f of fixedFeedsForMeal) {
      if (f.perMealTarget > 0) {
        allFeeds.push({
          name: f.name,
          amount: f.perMealTarget,
          protein: f.protein,
          price: f.price,
        });
        totalAmount += f.perMealTarget;
        totalProteinWeight += f.perMealTarget;
        totalProtein += f.perMealTarget * (f.protein / 100);
      }
    }

    if (
      neededPerMeal > 0 &&
      fullCourseList.length > 0 &&
      fullCourseTargetProtein > 0
    ) {
      let updatedFullCourseList = [...fullCourseList];

      for (let i = 0; i < updatedFullCourseList.length; i++) {
        const feed = updatedFullCourseList[i];
        if (feed.isCombination && feed.getRatiosForDay) {
          const dayRatiosResult = feed.getRatiosForDay(day);
          const dayRatios = dayRatiosResult.ratios;
          const startedStatus = dayRatiosResult.startedStatus;
          const weightedValues = feed.getWeightedValues(day);
          feed.protein = weightedValues.protein;
          feed.combinationFeeds = feed.feedInfoList.map((subFeed) => ({
            ...subFeed,
            ratio: dayRatios[subFeed.name] || 0,
            isStarted: startedStatus[subFeed.name] || false,
          }));
        }
      }

      fullCourseList = updatedFullCourseList;

      let highProteinCombo = null;
      for (const feed of fullCourseList) {
        if (feed.isCombination && feed.getRatiosForDay) {
          highProteinCombo = feed;
          break;
        }
      }

      if (highProteinCombo) {
        const dayRatiosResult = highProteinCombo.getRatiosForDay(day);
        const dayRatios = dayRatiosResult.ratios;
        const startedStatus = dayRatiosResult.startedStatus;

        const activeFeeds = [];
        let totalRatio = 0;
        let weightedProteinSum = 0;

        for (const subFeed of highProteinCombo.feedInfoList) {
          if (!startedStatus[subFeed.name]) continue;

          const ratio = dayRatios[subFeed.name] || 0;
          if (ratio <= 0) continue;

          activeFeeds.push({
            name: subFeed.name,
            ratio: ratio,
            protein: subFeed.protein / 100,
            price: subFeed.price,
          });

          totalRatio += ratio;
          weightedProteinSum += ratio * (subFeed.protein / 100);
        }

        if (activeFeeds.length > 0 && totalRatio > 0) {
          const comboProtein = weightedProteinSum / totalRatio;
          const targetP = fullCourseTargetProtein / 100;

          const highProteinNames = highProteinCombo.feedInfoList.map(
            (f) => f.name
          );
          const lowProteinFeeds = fullCourseList.filter((f) => {
            const protein = parseFloat(f.protein) || 0;
            const startDay = f.startDay || 1;
            return (
              protein < 20 &&
              !f.isCombination &&
              !highProteinNames.includes(f.name) &&
              startDay <= day
            );
          });

          if (lowProteinFeeds.length > 0) {
            const lowFeed = lowProteinFeeds[0];
            const lowP = (parseFloat(lowFeed.protein) || 0) / 100;

            let highAmount =
              (neededPerMeal * (targetP - lowP)) / (comboProtein - lowP);
            let lowAmount = neededPerMeal - highAmount;

            if (highAmount < 0) {
              highAmount = 0;
              lowAmount = neededPerMeal;
            }
            if (lowAmount < 0) {
              lowAmount = 0;
              highAmount = neededPerMeal;
            }
            if (highAmount > neededPerMeal) {
              highAmount = neededPerMeal;
              lowAmount = 0;
            }

            if (lowAmount > 0.01) {
              allFeeds.push({
                name: lowFeed.name,
                amount: Math.round(lowAmount * 1000) / 1000,
                protein: parseFloat(lowFeed.protein) || 0,
                price: lowFeed.price || 0,
              });
              totalAmount += lowAmount;
              totalProteinWeight += lowAmount;
              totalProtein +=
                (lowAmount * (parseFloat(lowFeed.protein) || 0)) / 100;
            }

            if (highAmount > 0.01) {
              for (const feed of activeFeeds) {
                const subAmount = (highAmount * feed.ratio) / totalRatio;
                if (subAmount > 0.01) {
                  allFeeds.push({
                    name: feed.name,
                    amount: Math.round(subAmount * 1000) / 1000,
                    protein: feed.protein * 100,
                    price: feed.price || 0,
                  });
                  totalAmount += subAmount;
                  totalProteinWeight += subAmount;
                  totalProtein += subAmount * feed.protein;
                }
              }
            }

            const finalProtein =
              totalProteinWeight > 0
                ? (totalProtein / totalProteinWeight) * 100
                : 0;
            const actualPerSheep = totalAmount / actualSheepCount;

            mealPlan.push({
              day: day,
              isMorning: isMorning,
              mealIndex: mealIdx,
              feeds: allFeeds,
              totalAmount: totalAmount,
              perSheep: Math.round(actualPerSheep * 1000) / 1000,
              protein: Math.round(finalProtein * 10) / 10,
              targetProtein: targetProtein,
              weight: dayData ? dayData.weight : 0,
            });
            continue;
          }
        }
      }

      const activeFullCourse = fullCourseList.filter((f) => {
        const startDay = f.startDay || 1;
        return startDay <= day;
      });

      if (activeFullCourse.length > 0) {
        const sorted = [...activeFullCourse].sort(
          (a, b) => (a.protein || 0) - (b.protein || 0)
        );
        const lowP = sorted[0].protein || 0;
        const highP = sorted[sorted.length - 1].protein || 0;

        if (fullCourseTargetProtein <= lowP) {
          const feed = sorted[0];
          const amount = neededPerMeal;

          if (feed.isCombination && feed.combinationFeeds) {
            for (const subFeed of feed.combinationFeeds) {
              const subStartDay = subFeed.startDay || 1;
              if (subStartDay > day) continue;
              const ratio = subFeed.ratio || 0;
              if (ratio <= 0) continue;
              const subAmount = amount * ratio;
              if (subAmount > 0.001) {
                allFeeds.push({
                  name: subFeed.name,
                  amount: Math.round(subAmount * 1000) / 1000,
                  protein: subFeed.protein,
                  price: subFeed.price,
                });
                totalAmount += subAmount;
                totalProteinWeight += subAmount;
                totalProtein += subAmount * (subFeed.protein / 100);
              }
            }
          } else {
            allFeeds.push({
              name: feed.name,
              amount: Math.round(amount * 1000) / 1000,
              protein: feed.protein || 0,
              price: feed.price || 0,
            });
            totalAmount += amount;
            totalProteinWeight += amount;
            totalProtein += amount * (feed.protein / 100);
          }
        } else if (fullCourseTargetProtein >= highP) {
          const feed = sorted[sorted.length - 1];
          const amount = neededPerMeal;

          if (feed.isCombination && feed.combinationFeeds) {
            for (const subFeed of feed.combinationFeeds) {
              const subStartDay = subFeed.startDay || 1;
              if (subStartDay > day) continue;
              const ratio = subFeed.ratio || 0;
              if (ratio <= 0) continue;
              const subAmount = amount * ratio;
              if (subAmount > 0.001) {
                allFeeds.push({
                  name: subFeed.name,
                  amount: Math.round(subAmount * 1000) / 1000,
                  protein: subFeed.protein,
                  price: subFeed.price,
                });
                totalAmount += subAmount;
                totalProteinWeight += subAmount;
                totalProtein += subAmount * (subFeed.protein / 100);
              }
            }
          } else {
            allFeeds.push({
              name: feed.name,
              amount: Math.round(amount * 1000) / 1000,
              protein: feed.protein || 0,
              price: feed.price || 0,
            });
            totalAmount += amount;
            totalProteinWeight += amount;
            totalProtein += amount * (feed.protein / 100);
          }
        } else {
          let lowAmount =
            (neededPerMeal * (fullCourseTargetProtein - highP)) /
            (lowP - highP);
          let highAmount = neededPerMeal - lowAmount;

          if (lowAmount < 0) {
            lowAmount = 0;
            highAmount = neededPerMeal;
          }
          if (highAmount < 0) {
            highAmount = 0;
            lowAmount = neededPerMeal;
          }

          const lowFeed = sorted[0];
          if (lowAmount > 0.001) {
            if (lowFeed.isCombination && lowFeed.combinationFeeds) {
              for (const subFeed of lowFeed.combinationFeeds) {
                const subStartDay = subFeed.startDay || 1;
                if (subStartDay > day) continue;
                const ratio = subFeed.ratio || 0;
                if (ratio <= 0) continue;
                const subAmount = lowAmount * ratio;
                if (subAmount > 0.001) {
                  allFeeds.push({
                    name: subFeed.name,
                    amount: Math.round(subAmount * 1000) / 1000,
                    protein: subFeed.protein,
                    price: subFeed.price,
                  });
                  totalAmount += subAmount;
                  totalProteinWeight += subAmount;
                  totalProtein += subAmount * (subFeed.protein / 100);
                }
              }
            } else {
              allFeeds.push({
                name: lowFeed.name,
                amount: Math.round(lowAmount * 1000) / 1000,
                protein: lowFeed.protein || 0,
                price: lowFeed.price || 0,
              });
              totalAmount += lowAmount;
              totalProteinWeight += lowAmount;
              totalProtein += lowAmount * (lowFeed.protein / 100);
            }
          }

          const highFeed = sorted[sorted.length - 1];
          if (highAmount > 0.001) {
            if (highFeed.isCombination && highFeed.combinationFeeds) {
              for (const subFeed of highFeed.combinationFeeds) {
                const subStartDay = subFeed.startDay || 1;
                if (subStartDay > day) continue;
                const ratio = subFeed.ratio || 0;
                if (ratio <= 0) continue;
                const subAmount = highAmount * ratio;
                if (subAmount > 0.001) {
                  allFeeds.push({
                    name: subFeed.name,
                    amount: Math.round(subAmount * 1000) / 1000,
                    protein: subFeed.protein,
                    price: subFeed.price,
                  });
                  totalAmount += subAmount;
                  totalProteinWeight += subAmount;
                  totalProtein += subAmount * (subFeed.protein / 100);
                }
              }
            } else {
              allFeeds.push({
                name: highFeed.name,
                amount: Math.round(highAmount * 1000) / 1000,
                protein: highFeed.protein || 0,
                price: highFeed.price || 0,
              });
              totalAmount += highAmount;
              totalProteinWeight += highAmount;
              totalProtein += highAmount * (highFeed.protein / 100);
            }
          }
        }
      }
    }

    const finalProtein =
      totalProteinWeight > 0 ? (totalProtein / totalProteinWeight) * 100 : 0;
    const actualPerSheep = totalAmount / actualSheepCount;

    mealPlan.push({
      day: day,
      isMorning: isMorning,
      mealIndex: mealIdx,
      feeds: allFeeds,
      totalAmount: totalAmount,
      perSheep: Math.round(actualPerSheep * 1000) / 1000,
      protein: Math.round(finalProtein * 10) / 10,
      targetProtein: targetProtein,
      weight: dayData ? dayData.weight : 0,
    });
  }

  const allFeedNames = proteinFeeds.map((f) => f.name);
  if (additives && additives.length > 0) {
    for (const add of additives) {
      if (!allFeedNames.includes(add.name)) {
        allFeedNames.push(add.name);
      }
    }
  }

  const previewData = [];
  for (let day = 1; day <= days; day++) {
    const morning = mealPlan[(day - 1) * 2];
    const afternoon = mealPlan[(day - 1) * 2 + 1];
    if (!morning || !afternoon) continue;

    const feedMap = {};
    for (const meal of [morning, afternoon]) {
      for (const f of meal.feeds) {
        if (!feedMap[f.name]) {
          feedMap[f.name] = {
            name: f.name,
            protein: f.protein || 0,
            price: f.price || 0,
            morning: 0,
            afternoon: 0,
          };
        }
      }
    }

    for (const f of morning.feeds) {
      if (feedMap[f.name]) feedMap[f.name].morning = f.amount || 0;
    }
    for (const f of afternoon.feeds) {
      if (feedMap[f.name]) feedMap[f.name].afternoon = f.amount || 0;
    }

    const additiveDataMap = generateAdditiveData(additives, days, peakDayForFeed, highProteinFullCourseStartDay);
    const dayAdditives = additiveDataMap[day] || {};
    for (const [name, amount] of Object.entries(dayAdditives)) {
      if (!feedMap[name]) {
        feedMap[name] = {
          name,
          protein: 0,
          price: 0,
          morning: 0,
          afternoon: 0,
        };
      }
      feedMap[name].morning = (feedMap[name].morning || 0) + amount;
      feedMap[name].afternoon = (feedMap[name].afternoon || 0) + amount;
    }

    const feedItems = [];
    let totalWeight = 0;
    let totalCost = 0;
    let totalProteinWeight = 0;
    let totalProtein = 0;

    for (const [name, data] of Object.entries(feedMap)) {
      const morningWeight = Math.round((data.morning || 0) * 10) / 10;
      const afternoonWeight = Math.round((data.afternoon || 0) * 10) / 10;
      const dayTotal = morningWeight + afternoonWeight;

      if (dayTotal > 0.01) {
        feedItems.push({
          name: name,
          morningWeight: morningWeight,
          afternoonWeight: afternoonWeight,
          price: data.price || 0,
          protein: data.protein || 0,
        });
        totalWeight += dayTotal;
        totalCost += dayTotal * (data.price || 0);
        if (data.protein > 0) {
          totalProteinWeight += dayTotal;
          totalProtein += dayTotal * (data.protein / 100);
        }
      }
    }

    const avgWeight = totalWeight / actualSheepCount;
    const avgProtein =
      totalProteinWeight > 0 ? (totalProtein / totalProteinWeight) * 100 : 0;

    previewData.push({
      dayIndex: day,
      feedItems: feedItems,
      morningSheepCount: actualSheepCount,
      afternoonSheepCount: actualSheepCount,
      totalQuantity: Math.round(avgWeight * 1000) / 1000,
      totalCost: Math.round(totalCost * 100) / 100,
      totalProtein: Math.round(avgProtein * 10) / 10,
      isPredicted: false,
    });
  }

  const lastDay = previewData[previewData.length - 1];

  console.log("\n========== 国标模式完成 ==========");
  console.log(`总天数: ${days}天`);
  console.log(`加料粒度: ${feedGranularity === "day" ? "按天" : "按顿"}`);
  console.log(
    `蛋白峰值日: 第${finalProteinPeakDay}天, 最小蛋白日: 第${minDay}天`
  );
  console.log(`实际增长起始日: 第${actualGrowthStartDay}天`);
  console.log(`后期稳定蛋白: ${effectiveMinProtein}%`);
  console.log(`是否使用新逻辑: ${useNewLogic ? "✅ 是" : "❌ 否"}`);

  console.log("[generateNationalPlan] 📊 实际蛋白结果（前20天）:");
  for (let i = 0; i < Math.min(20, previewData.length); i++) {
    const day = previewData[i];
    console.log(
      `  第${day.dayIndex}天: ${day.totalProtein}% (目标: ${
        mealPlan[i * 2]?.targetProtein || "N/A"
      }%)`
    );
  }

  if (lastDay) {
    console.log(`最后一天均重: ${lastDay.totalQuantity}斤/只`);
    console.log(`最后一天蛋白: ${lastDay.totalProtein}%`);
  }
  console.log("====================================\n");

  console.log("[DEBUG] 4. 返回前 finalProteinPeakDay =", finalProteinPeakDay);
  console.log("[DEBUG] 4. 返回前 actualGrowthStartDay =", actualGrowthStartDay);
  console.log("[DEBUG] 4. 返回前 useNewLogic =", useNewLogic);

  return {
    success: true,
    data: previewData,
    totalCheck: {
      totalDays: days,
      lastDayWeight: lastDay ? lastDay.totalQuantity : 0,
      lastDayProtein: lastDay ? lastDay.totalProtein : 0,
      proteinPeakDay: finalProteinPeakDay,
      minDay: minDay,
      actualGrowthStartDay: actualGrowthStartDay,
    },
  };
}

// ============================================================
// 主入口
// ============================================================

function generateTargetPlan(params) {
  const { feedMode = "national" } = params;

  console.log("[generateTargetPlan] 参数:");
  console.log(`  feedMode: ${feedMode}`);

  if (feedMode === "national") {
    return generateNationalPlan(params);
  }

  return { success: false, error: "仅支持 national 模式" };
}

// ============================================================
// 导出
// ============================================================

module.exports = {
  generateTargetPlan,
  generateFixedFeedArray,
  getRandomPeakFeed,
  getRandomPeakProtein,
  queryFeedAmount,
  queryDMIAndCP,
  getStrawPerMeal,
  GROW_FEMALE_TABLE,
  GROW_MALE_TABLE,
  LAMB_TABLE,
};